// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { settleMount } from "#ce/framework/mount-ready";

/** Resolves to `callback`'s result after all controls mount, or undefined if any is absent or fails. */
export async function whenSelectsReady(controls, callback) {
  const mounted = await Promise.all(Array.from(controls, settleMount));

  if (mounted.every(Boolean)) {
    return callback(mounted);
  }
}
